import { Component, Input, Output, EventEmitter } from "@angular/core";

// Path: src/app/components/buttons/button/button.component.ts
@Component({
    selector: 'mwo-main-button',
    templateUrl: './main-button.component.html',
    styleUrls: ['./main-button.component.scss'],
})
export class MainButtonComponent {

    private _text: string;
    @Input() disabled: boolean = false;


  @Input()
    set text(value: string) {
        this._text = value;
    }

    get text(): string {
        return this._text;
    }

    @Output() onClick = new EventEmitter();

    constructor() { }

    click() {
      if (!this.disabled) {
        this.onClick.emit();
      }
    }

}
